import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const skills = [
  "Indholdsstrategi",
  "Forandringsledelse",
  "SEO & Trafikvækst",
  "Journalistik",
  "Medarbejderledelse",
  "Digital Transformation",
  "Redaktionschef-kompetencer",
  "Datadrevet optimering"
];

const education = [
  { title: "Journalist", institution: "Danmarks Medie- og Journalistikshøjskole", icon: "Book" },
  { title: "Lederens Psykologi", institution: "Mannaz", icon: "Users" },
  { title: "DR's talent- og lederudvikling", institution: "Væksthuset, DR Nyheder", icon: "TrendingUp" },
  { title: "The Newsroom Challenge", institution: "The Poynter Institute, Florida", icon: "Award" },
  { title: "Ledelse af flermediale redaktioner", institution: "University of Texas at Austin", icon: "Globe" },
  { title: "Projektlederuddannelse", institution: "Aller Media", icon: "CheckCircle" }
];

const Skills = () => {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-start">
          
          {/* Skills Section */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-black text-slate-900 mb-10 tracking-tight">Kernekompetencer</h2>
            <div className="flex flex-wrap gap-4">
              {skills.map((skill, index) => (
                <motion.span 
                  key={index}
                  whileHover={{ scale: 1.05, backgroundColor: "#0f172a", color: "#fff" }}
                  className="inline-flex items-center px-6 py-3 rounded-xl text-sm font-bold bg-stone-50 text-slate-700 border border-stone-200 cursor-default transition-all duration-300"
                >
                  {skill}
                </motion.span>
              ))}
            </div>
            <p className="mt-10 text-lg text-slate-600 leading-relaxed font-light italic">
              Min værktøjskasse kombinerer tunge publicistiske dyder med moderne, datadrevet forretningsforståelse. Jeg er ofte trådt ind i rollen som redaktionschef eller redaktionel leder med opgaven at fremtidssikre mediet og skabe resultater.
            </p>

            <motion.div 
              whileHover={{ x: 10 }}
              className="mt-12 p-10 bg-slate-900 rounded-[2rem] text-white relative shadow-2xl overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16 blur-xl" />
              
              <p className="text-xl font-light leading-relaxed italic relative z-10 pt-4">
                "Per er helt eminent til at sætte en klar retning, skabe god stemning og give sine medarbejdere plads. Det er meget nemt at trives med ham som chef"
              </p>
              
              <div className="mt-8 flex items-center gap-4 relative z-10">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/9156b7ad9768dabbd1486a5021f9991fb512a0d6d6c844e6b5b41380a57b274ba7bc4b27b2a4de1f0a85d0c05b5620e1/images/aW1hZ2UvanBlZw==/6d0580e3cb5f7fc5c0c8317e96959b5f.jfif" 
                  alt="Kasper Skov Jensen" 
                  className="w-14 h-14 rounded-full object-cover border-2 border-slate-700 shadow-lg"
                />
                <div>
                  <p className="text-base font-bold text-white tracking-wide">Kasper Skov Jensen</p>
                  <p className="text-xs font-black uppercase tracking-[0.15em] text-slate-400 mt-1">Tidligere medarbejder</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Education Section */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-stone-50 p-10 lg:p-16 rounded-[3rem] border border-stone-100"
          >
            <h2 className="text-4xl font-black text-slate-900 mb-12 tracking-tight">Uddannelse</h2>
            <div className="space-y-8">
              {education.map((edu, index) => (
                <motion.div 
                  key={index} 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start group"
                >
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-2xl bg-white text-slate-900 shadow-sm group-hover:bg-slate-900 group-hover:text-white transition-all duration-300">
                      <SafeIcon name={edu.icon} className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="ml-6">
                    <h3 className="text-xl font-bold text-slate-900 leading-tight mb-1">{edu.title}</h3>
                    <p className="text-slate-500 font-medium text-sm italic">{edu.institution}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Skills;